import { render } from "./ProveedorCreate.vue?vue&type=template&id=63320b10&scoped=true"
import script from "./ProveedorCreate.vue?vue&type=script&lang=js"
export * from "./ProveedorCreate.vue?vue&type=script&lang=js"

import "./ProveedorCreate.vue?vue&type=style&index=0&id=63320b10&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\rotcen_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63320b10"]])

export default __exports__